import UrlUtils from "./url-utils";

type UrlParameter = {
    name: string,
    value: string | number | Date | boolean
}

class UrlBuilder {
    private _url: string;
    private _params: UrlParameter[] = [];

    constructor(url: string) {
        this._url = url;
    }

    appendPath(path: string) {
        this._url = UrlUtils.join(this._url, path);
        return this;
    }

    appendParam(name: string, value: string | number | Date | boolean, existsCheck = false) {
        if (existsCheck && !value) {
            return this;
        }
        this._params.push({ name: name, value: value });
        return this;
    }

    toString() {
        if (this._params.length === 0) {
            return this._url;
        }

        const parameters = this._params.map(x => `${x.name}=${encodeURIComponent(x.value.toString())}`).join("&");

        return `${this._url}?${parameters}`;
    }

}

export default UrlBuilder;